"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REVIEWS_CAROUSEL_LIMITS = void 0;
exports.REVIEWS_CAROUSEL_LIMITS = {
    MAX_REVIEWS: 5,
};
